import React, { useState, useEffect } from "react";
import SearchIcon from "../../../../svgs/search.svg";
import AddCircleIcon from "../../../../svgs/add-circle.svg";
import "./POFilter.scss";
import useDebounce from "../../../../../Shared/GeographyFilters/hooks/useDebounce";

const POFilter = ({ poNumber, setPONumber, setShowPOCreateModal }) => {
  const [localPONumber, setLocalPONumber] = useState(poNumber);
  const debouncedPONumber = useDebounce(localPONumber, 400);

  useEffect(() => {
    setPONumber(debouncedPONumber);
  }, [debouncedPONumber, setPONumber]);

  return (
    <div className="filters-section">
      <div className="search-input">
        <img src={SearchIcon} alt="Search Icon" className="search-icon" />
        <input
          type="text"
          id="po-number"
          value={localPONumber}
          onChange={(e) => setLocalPONumber(e.target.value)}
          placeholder="Search"
          className="search-input-field"
        />
      </div>
      <button className="create-btn" onClick={() => setShowPOCreateModal(true)}>
        <img src={AddCircleIcon} alt="Search Icon" className="btn-icon" />
        Create New PO
      </button>
    </div>
  );
};

export default POFilter;
